<template>
   <div class="page-wrapper page-fixed select">
        <div class="page-background-color-white page-absolute box ">
            <div class="page-absolute close" @click="closeFn">×</div>
            <p class="page-text-center">请通过图形验证</p>
                <slide-verify :l="42"
                :r="10"
                :w="300"
                :h="140"
                @success="onSuccess"
                @fail="onFail"
                @refresh="onRefresh"
                :slider-text="text"
                ></slide-verify>
        </div>
   </div>
</template>

<script>
export default {
    name: "DragSlider",
    props: {

    },
    data: function () {
        return {
            text: "向右滑动"
        }
    },
    methods: {
        onSuccess: function () {
            this.$emit('isOk');
        },
        onFail: function () {
            this.$dialog.error("请重试！");
        },
        closeFn: function () {
            this.$emit('close', false);
        }
    }
}
</script>

<style scoped>
.select {
    top: 0;
    left: 0;
    z-index: 100;
}
.box {
    width: 90%;
    height: 5.7rem;
    border: 1px solid #ccc;
    border-radius: .2rem;
    top: 62%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.box p {
    line-height: 1rem;
    font-size: .34rem;
}
.slide-verify {
    margin: 0 auto;
}
.close {
    top: .15rem;
    right: .15rem;
    width: .4rem;
    height: .4rem;
    text-align: center;
    line-height: .4rem;
    font-size: .4rem;
}
</style>